// Title-cased fallback label for a role id — used when the Role Registry (DB,
// seeded from rbac-config.json) has no display name for it (e.g. before the
// catalogue has loaded, or for an id the registry doesn't return).
//
// The AUTHORITATIVE role names live in rbac-config.json → the Role Registry and
// are resolved at runtime via useRoleNames(); this is only the safety net so a
// raw enum / "debug string" (ORG_CO_OWNER, PRODUCT_MANAGER) is never shown.
export const prettyRole = (role) => {
    if (!role) return '—';
    // Only prettify SNAKE_CASE enum ids (ORG_OWNER → "Org Owner"). Leave anything
    // else (e.g. an unresolved custom-role ObjectId) untouched rather than mangling it.
    if (!/^[A-Z0-9_]+$/.test(role)) return role;
    return role
        .toLowerCase()
        .split('_')
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
};
